import { LogService } from "./log.service";
import { LogResolvers } from "./resolvers/_log-resolver";

export const LogServices = [
    LogService,

    LogResolvers
]